module.exports = __webpack_public_path__ + "img/BS.1ed7c6c9.png";